import * as React from 'react';
const DEFAULT_TAG = 'div';
export const FlexItem = React.forwardRef(function FlexItem(props, ref) {
    const { component: Component = DEFAULT_TAG, order = 0, flexShrink = 1, flexGrow = 0, alignSelf = 'auto', flexBasis = 0, forwardRef = ref, style = {}, ...rest } = props;
    return React.createElement(Component, Object.assign({ ref: forwardRef, style: { order, flexShrink, flexGrow, flexBasis, alignSelf, ...style } }, rest));
});
//# sourceMappingURL=FlexItem.js.map